import apiForluz from './api';

export class PersonalizacaoService {
  getPersonalizacaoHome = async (matricula, plano, token) => {
    const response = await apiForluz.get('ObterPersonalizacaoHome', {
      params: {
        matricula,
        plano,
        token,
      },
    });
    return response.data[0].JsonPreferencia;
  };

  setPersonalizacaoHome = async (matricula, plano, preferencias, token) => {
    const preferenciasJSON = JSON.stringify(preferencias).replaceAll(`"`, `'`);
    const response = await apiForluz.post('SalvarPersonalizacaoHome', {
      matricula,
      plano,
      preferencias: preferenciasJSON,
      token,
    });
    return response.data[0].linhasafetadas;
  };

  getTelasPorPerfil = async (plano, sitpart, beneficio = null) => {
    try {
      const response = await apiForluz.get('ObterTelasPerfilParticipante', {
        params: {
          plano,
          sitpart,
          beneficio,
        },
      });
      return response.data;
    } catch (e) {
      return [];
    }
  };

  getMenuAtendimentoVirtual = async (plano, sitpart, beneficio = null) => {
    try {
      const response = await apiForluz.get('ObterMenuAtendimentoVirtual', {
        params: {
          aplicacao: 'Portal',
          plano,
          sitpart,
          beneficio,
        },
      });
      return response.data;
    } catch (e) {
      return [];
    }
  };
}
